import { ReadonlyRadioGroup } from '@exam-center/components';
import { Box, Flex, Grid, ReadonlyField, SectionTitle, Text } from '@shared/components';

import { QUESTIONNAIRE_TEMPLATE_OPTIONS } from '../../constants';

export interface QuestionnaireSettingsReadonlyFieldsProps {
  values: {
    enabled: boolean;
    templateId: string | null;
  };
}

export default function QuestionnaireSettingsReadonlyFields(
  props: Readonly<QuestionnaireSettingsReadonlyFieldsProps>,
) {
  const { values } = props;

  const templateLabel =
    QUESTIONNAIRE_TEMPLATE_OPTIONS.find((o) => o.value === values.templateId)?.label ?? '';

  return (
    <>
      <SectionTitle title='Questionnaire Settings' />
      <Grid sx={{ gap: (theme) => theme.spacing(6), gridTemplate: '1fr / 240px 1fr' }}>
        <Box>
          <Text variant='body1Semibold'>การทำแบบสอบถาม</Text>
        </Box>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
          <ReadonlyRadioGroup
            options={[
              {
                label: 'ไม่ทำแบบสอบถาม',
                checked: values.enabled === false,
              },
              {
                label: 'ทำแบบสอบถาม',
                checked: values.enabled === true,
              },
            ]}
          />
          {values.enabled ? (
            <Flex sx={{ pl: (theme) => theme.spacing(8) }}>
              <ReadonlyField label='เลือก Questionnaire Template' content={templateLabel} />
            </Flex>
          ) : null}
        </Flex>
      </Grid>
    </>
  );
}
